import { useState, useEffect } from 'react';

import { subscriptionsBill, subscriptionsExtend } from 'services/payments-service';
import { Loader2, themes, Confirm } from 'libs/ui';
import { Info } from './extension-form.styled';

import { useTranslation } from 'react-i18next';

export const ExtensionForm = (props) => {
  const { t } = useTranslation();

  const { id, mean_id, close, refresh } = props;
  const [info, setInfo] = useState(null);

  useEffect(() => {
    subscriptionsBill(id).then((data) => {
      setInfo(data);
    });
  }, [id]);

  /**
   * activate
   * @returns
   */
  const activate = async () => {
    try {
      await subscriptionsExtend(id);
      refresh();
      close(true);
    } catch (errors) {
      if (errors && errors.data) {
      }
    }
  };

  if (!info) {
    return (
      <Confirm
        center
        width={'470px'}
        title={t('messages.Активировать абонемент №') + mean_id}
        // type="danger"
        info={<Loader2 height={'80px'} />}
        cancelButton={{ text: t('buttons.Отменить'), func: () => close() }}
      />
    );
  }

  const balance = Math.round(info.amount / 100);
  const date = info.pass_date;

  return (
    <Confirm
      center
      width={'470px'}
      title={t('messages.Активировать абонемент №') + mean_id}
      // type="danger"
      info={
        <Info>
          <p>
            {t('messages.Абонемент будет активирован до')} <b>{date}</b>,
          </p>
          <p>
            {t('messages.Баланс')}: <b>{balance}</b>
            {t('grid.₽')}. {t('messages.Продолжить?')}
          </p>
        </Info>
      }
      cancelButton={{ text: t('buttons.Отменить'), func: () => close() }}
      acceptButton={{ text: t('buttons.Активировать'), func: () => activate(), theme: themes.blue }}
    />
    // <Popup2 w={470}>
    //   <Content>
    //     <Title>
    //       {t('messages.Активировать абонемент №')}
    //       {mean_id}
    //     </Title>

    //     <Buttons>
    //       <Button type="button" onClick={() => close()}>
    //         {t('buttons.Отменить')}
    //       </Button>
    //       <Button theme={themes.blue} onClick={activate}>
    //         {t('buttons.Активировать')}
    //       </Button>
    //     </Buttons>
    //   </Content>
    // </Popup2>
  );
};
